import { getCookieConsentValue } from "react-cookie-consent";

const getPublishableKey = () => {
    // return 'pk_test_51N3va6F96aQvC3ShCaxsTT9YeVVqHC6F8H9b4VBI8gSVFu6lHWjz2pR2SEQZOysSSfPvC5Xo5qlmqjYoqLbCYteh00ewNgZZuI'
    return 'pk_live_51N3va6F96aQvC3ShoBshOe343cgBwdAZFqiWkV7VqPLi6bgrMakhYyzmWKtlBNjXIckt6kXvYeQxuppv1n0MziPE006UvSDGX3'
}

export default getPublishableKey;